import { AgreementStatusTypes } from 'models'
import { Moment } from 'moment'
import { PaginationProps, SortDirection, User } from 'utilities'

export enum AgreementsTableSortProps {
  AGREEMENTS = 'name',
  STORES = 'scopes.filters.brands.name',
  BUDGET = 'budgetRemaining',
  PERIOD = 'startDate',
  STATUS = 'status'
}

export type AgreementFilterDTO = {
  name: string
  brandName: string
  projectName: string
  minAgreementBudget: number
  maxAgreementBudget: number
  agreementStart: string
  agreementEnd: string
  agreementStatus: AgreementStatusTypes
}

export type AgreementsTableSearchProps = {
  name: string
  brandName: string
  projectName: string
  minAgreementBudget: number
  maxAgreementBudget: number
  agreementStart: any
  agreementEnd: any
  agreementStatus: AgreementStatusTypes
}

export const initialAgreementsTableSearchProps: AgreementsTableSearchProps = {
  name: '',
  brandName: '',
  projectName: '',
  minAgreementBudget: null,
  maxAgreementBudget: null,
  agreementStart: null,
  agreementEnd: null,
  agreementStatus: '' as AgreementStatusTypes
}

export const initialAgreementsTablePaginationProps: PaginationProps<
  AgreementsTableSortProps
> = {
  page: 0,
  size: 15,
  sortDirection: SortDirection.ASC,
  sortProp: AgreementsTableSortProps.AGREEMENTS,
  totalElements: 0,
  totalPages: 0
}

export const agreementsTableNeedTimeoutProps: Array<
  keyof AgreementsTableSearchProps
> = ['name', 'brandName', 'projectName']

export enum AgreementStatusesLabels {
  DRAFT = 'DRAFT', PENDING = 'PENDING APPROVAL', SENT = 'SENT FOR APPROVAL', ACTIVE = 'ACTIVE', NOT_ACTIVE = 'NOT ACTIVE'
}

export const getAgreementStatusByLabel = (label: AgreementStatusesLabels): AgreementStatusTypes => {
  switch (label) {
    case AgreementStatusesLabels.DRAFT:
      return User.isShopOwner() ? AgreementStatusTypes.DRAFT_STORE : AgreementStatusTypes.DRAFT_PROJECT
    case AgreementStatusesLabels.PENDING:
      return User.isShopOwner() ? AgreementStatusTypes.PENDING_STORE_APPROVAL
        : AgreementStatusTypes.PENDING_PROJECT_APPROVAL
    case AgreementStatusesLabels.SENT:
      return User.isShopOwner() ? AgreementStatusTypes.PENDING_PROJECT_APPROVAL
        : AgreementStatusTypes.PENDING_STORE_APPROVAL
    case AgreementStatusesLabels.ACTIVE:
      return AgreementStatusTypes.AGREED
    case AgreementStatusesLabels.NOT_ACTIVE:
        return AgreementStatusTypes.EXPIRED
    default:
      return null
  }
}
